<template>
	<section class="section">
		<div class="container">

			<div class="columns">
				<div class="column is-6 is-offset-3">


					<ModalHeaderTitle :title="'Verifica tu email'" />

                    <article class="message is-danger" v-if="error">
                        <div class="message-body">{{ error }}</div>
                    </article>

                    <div v-if="verified">
                        <article class="message is-info">
                            <div class="message-body"><font-awesome-icon icon="check" /> Se ha verificado tu email correctamente</div>
                        </article>
                        <router-link class="button is-info is-fullwidth" to="/jugar">Ir a jugar</router-link>
                    </div>

                    
                    <div v-else>
                        <p>Te hemos enviado un correo a tu cuenta <span class="tag">{{ user.user.email }}</span> para verificar la direccion de tu correo electronico, en ocaciones puede que tarde unos segundos en llegar.</p>
                        <p>Si no recibiste el correo haz click en el siguiente boton para volver a reenviar el mensaje de verificación.</p>
                        
                        <article class="message is-info" v-if="renvio">
                            <div class="message-body"><font-awesome-icon icon="check" /> Se ha reenviado el correo de verificación</div>
                        </article>
                        <button class="button is-info is-fullwidth" @click="renviarMensaje" :disabled="renvio">Reenviar correo de verificación</button>
                    </div>

					
				</div>
			</div>
		</div>
	</section>
</template>

<script>
    import ModalHeaderTitle from '@/components/ModalHeaderTitle'
    import {mapState} from 'vuex'

	export default {
		components: { ModalHeaderTitle },
		name: 'EmailVerify',

		data() {
			return {
				token: '',
                verified: false,
                renvio: false,
                error: ''
			};
		},
		mounted(){
            this.token = this.$route.params.token
            if (this.user.user.email_verified_at != null) {
                this.$router.push({name: 'jugar'})
            }
            if(this.token != undefined){
                this.$store.dispatch('user/verifyEmail', {token: this.token})
                .then(resp => {
                    if (resp.error) {
                        this.error = resp.error
                    }else{
                        this.verified = true
                        this.$store.dispatch('user/fetchLoggedInUser')
                    }
                })
            }
        },
		methods: {
            renviarMensaje(){
                this.$store.dispatch('user/reSendVerificationEmail')
                .then(() => {
                    this.renvio = true
                    setTimeout(() => {
                        this.renvio = false
                    }, 10000);
                })
                this.error = ''
            }
        },
        computed: mapState('user',['user'])
	};
</script>

<style lang="css" scoped>
p{
    margin-bottom: 1em;
}
</style>
